module.exports = __webpack_public_path__ + "media/images/header__bg-b34fb43ac40120f1c8f8c4e0e0976cc5.jpg";